import { render, staticRenderFns } from "./carrinho-de-compras.html?vue&type=template&id=180b87a0&scoped=true&"
import script from "./carrinho-de-compras.vue?vue&type=script&lang=js&"
export * from "./carrinho-de-compras.vue?vue&type=script&lang=js&"
import style0 from "./carrinho-de-compras.less?vue&type=style&index=0&id=180b87a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b87a0",
  null
  
)

export default component.exports